// Cart items are labelled "Room — Window" by the configurator; group them per room for cart/checkout views
export const ROOM_SEP = ' — ';
export const UNASSIGNED_ROOM = 'Other shades';

export const splitRoomLabel = (label = '') => {
  const idx = label.indexOf(ROOM_SEP);
  if (idx === -1) return { room: label.trim(), window: '' };
  return { room: label.slice(0, idx).trim(), window: label.slice(idx + ROOM_SEP.length).trim() };
};

export const groupCartByRoom = (items = []) => {
  const groups = new Map();
  for (const item of items) {
    const { room, window } = splitRoomLabel(item.config?.room_label || '');
    const key = room || UNASSIGNED_ROOM;
    if (!groups.has(key)) groups.set(key, { room: key, items: [], subtotal: 0, quantity: 0 });
    const g = groups.get(key);
    const qty = item.quantity || 1;
    g.items.push({ ...item, windowLabel: window });
    g.subtotal += item.config?.total_price || 0; // total_price already includes quantity
    g.quantity += qty;
  }
  return [...groups.values()];
};

const esc = (v) => String(v ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const money = (n) => `$${(Number(n) || 0).toFixed(2)}`;

// <tr> rows for the print/PDF HTML tables (Description | Dimensions | Qty | Amount), grouped per room
export const roomGroupedRowsHtml = (items = []) =>
  groupCartByRoom(items)
    .map((g) => {
      const header = `<tr style="background:#fafaf9;"><td colspan="3" style="padding:10px 8px 6px;font-weight:700;border-bottom:1px solid #d6d3d1;">${esc(g.room)} <span style="font-weight:400;color:#888;font-size:11px;">· ${g.quantity} ${g.quantity === 1 ? 'shade' : 'shades'}</span></td><td style="padding:10px 8px 6px;text-align:right;font-weight:700;border-bottom:1px solid #d6d3d1;">${money(g.subtotal)}</td></tr>`;
      const rows = g.items.map((item) => {
        const product = (item.config?.product_type || 'Item').replace(/-/g, ' ');
        const title = item.windowLabel ? `<strong>${esc(item.windowLabel)}</strong><br><span style="color:#666;font-size:11px;">${esc(product)}</span>` : esc(product);
        return `<tr><td style="padding-left:20px;">${title}</td><td>${item.config?.width || '-'}" x ${item.config?.height || '-'}"</td><td>${item.quantity || 1}</td><td style="text-align:right;">${money(item.config?.total_price || 0)}</td></tr>`;
      });
      return header + rows.join('');
    })
    .join('');
